import { Component, computed, signal } from '@angular/core'

import { FormsModule } from '@angular/forms'
import { LabeledPropertyComponent } from '../labeled-property/labeled-property.component'
import { ModalBodyComponent } from '../modals/modal-body/modal-body.component'
import { ModalFooterComponent } from '../modals/modal-footer/modal-footer.component'
import { ModalHeaderComponent } from '../modals/modal-header/modal-header.component'
import { TBillSchedule1Rate, TBillSchedule1RateUpdateRequest } from '../settlements/tbill-settlements.types'
import { monthOnlyFormat } from 'src/app/shared/utilities/date'
import { NumberInputComponent } from '../number-input/number-input.component'
import { DateDisplayComponent } from '../date-display/date-display.component'

interface ModalState {
  rate: number
}

@Component({
  imports: [
    FormsModule,
    ModalHeaderComponent,
    ModalBodyComponent,
    ModalFooterComponent,
    LabeledPropertyComponent,
    DateDisplayComponent,
    NumberInputComponent,
  ],
  selector: 'app-update-tbill-schedule-1-rate-modal',
  styles: '',
  template: `
    <div app-modal-header>Update Schedule 1 Rate</div>

    @if(data()) {
        <div app-modal-body>
            <div app-labeled-property label="Month">
              <div app-date-display [value]="data()!.month" [format]="monthOnlyFormat"></div>
            </div>
            <div app-labeled-property label="Rate ($/(MW\u00A0MTH))">
                <div app-number-input
                  [value]="modalState().rate ?? 0"
                  (valueChange)="updateRate($event)"
                ></div>
            </div>
        </div>
    }

    <div app-modal-footer>
        <button
        class="action-btn primary"
        [disabled]="!canUpdate()"
        (click)="update()"
        >
        Update
        </button>
        <button class="action-btn" (click)="onCancel()()">Cancel</button>
    </div>
    `,
})
export class UpdateTBillSchedule1RateModalComponent {
  protected readonly monthOnlyFormat = monthOnlyFormat

  protected readonly modalState = signal<Partial<ModalState>>({})
  protected readonly data = signal<TBillSchedule1Rate | null>(null)
  protected readonly onUpdate = signal<(month: Date, req: TBillSchedule1RateUpdateRequest) => void>(() => void 0)
  protected readonly onCancel = signal<() => void>(() => void 0)


  protected readonly canUpdate = computed(() => {
    const state = this.modalState()
    return this.data() &&
      (
        !Number.isNaN(state.rate) &&
        state.rate != undefined
      )
  })

  init(overrides: Partial<{
    modalState: Partial<ModalState>,
    data: TBillSchedule1Rate,
    onUpdate: (month: Date, req: TBillSchedule1RateUpdateRequest) => void,
    onCancel: () => void
  }>) {
    this.modalState.update(v => ({ ...v, ...(overrides.modalState ?? {}) }))
    this.data.update(v => overrides.data ?? v)
    this.onUpdate.update(v => overrides.onUpdate ?? v)
    this.onCancel.update(v => overrides.onCancel ?? v)
  }

  updateRate(rate: number) {
    this.modalState.update(v => ({ ...v, rate }))
  }
  update() {
    this.onUpdate()(
      this.data()!.month,
      {
        rate: this.modalState().rate!,
      },
    )
  }
}
